@import '@hevoio/hevo-ui-toolkit/styles/variables';

$width: 312px;
$height: 10px;
$border-radius: $height * 0.5;

.progressBar {
  width: $width;
  height: $height;
  display: inline-block;
  border-radius: $border-radius;
  background: $secondary-bg;
  overflow: hidden;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    background-color: $primary;
    top: 0;
    left: 0;
    bottom: 0;
    border-radius: $border-radius;
    will-change: left, right;
    animation: indeterminate 2s linear infinite;
  }
}

.reverseBg .progressBar {
  background: $divider-color !important;
}

.grey .progressBar {
  &::before {
    background-color: $text-default;
  }
}

.extra {
  margin-top: $spacer;
}

@keyframes indeterminate {
  0% {
    left: -35%;
    right: 100%;
  }
  100% {
    left: 100%;
    right: -35%;
  }
}
